import React from 'react';

const NumericKeyboard = ({ value, onChange, onClose, allowDecimal = false, maxLength = null, isPhoneNumber = false, quickAmounts = null, label = 'จำนวน' }) => {
  const handleNumberClick = (num) => {
    const currentValue = value?.toString() || '';

    // Check max length
    if (maxLength && currentValue.length >= maxLength) {
      return;
    }

    // Handle decimal point
    if (num === '.' && !allowDecimal) {
      return;
    }

    if (num === '.' && currentValue.includes('.')) {
      return;
    }

    const newValue = currentValue + num;

    // For phone numbers, keep as string to preserve leading zeros
    if (isPhoneNumber) {
      onChange(newValue);
    } else {
      // For numbers, parse but handle edge cases
      if (newValue === '' || newValue === '.') {
        onChange(0);
      } else {
        const parsed = parseFloat(newValue);
        onChange(isNaN(parsed) ? newValue : parsed);
      }
    }
  };

  const handleBackspace = () => {
    const currentValue = value?.toString() || '';
    if (currentValue.length > 0) {
      const newValue = currentValue.slice(0, -1);
      if (isPhoneNumber) {
        onChange(newValue);
      } else {
        onChange(newValue === '' ? 0 : parseFloat(newValue) || 0);
      }
    }
  };

  const handleClear = () => {
    onChange(isPhoneNumber ? '' : 0);
  };

  const handleQuickAmount = (amount) => {
    onChange(amount);
  };

  const buttonClass = "w-full h-16 text-2xl font-bold rounded-lg shadow-md active:shadow-inner transition-all duration-100 active:scale-95";
  const numberButtonClass = buttonClass + " bg-white hover:bg-gray-50 text-gray-800 border-2 border-gray-200";
  const actionButtonClass = buttonClass + " bg-blue-500 hover:bg-blue-600 text-white";
  const dangerButtonClass = buttonClass + " bg-red-500 hover:bg-red-600 text-white";
  const successButtonClass = buttonClass + " bg-green-500 hover:bg-green-600 text-white";

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" onClick={onClose}>
      <div className="bg-gradient-to-br from-blue-50 to-purple-50 rounded-2xl shadow-2xl p-6 w-full max-w-md" onClick={(e) => e.stopPropagation()}>
        {/* Display */}
        <div className="mb-4 bg-white rounded-xl p-4 border-4 border-blue-300 shadow-inner">
          <div className="text-sm text-gray-500 mb-1">{label}</div>
          <div className="text-4xl font-bold text-right text-gray-800 min-h-[48px] flex items-center justify-end">
            {value?.toString() || '0'}
          </div>
        </div>

        {/* Quick Amount Buttons */}
        {quickAmounts && quickAmounts.length > 0 && (
          <div className="grid grid-cols-5 gap-2 mb-4">
            {quickAmounts.map((amount) => (
              <button
                key={amount.value}
                onClick={() => handleQuickAmount(amount.value)}
                className="bg-gradient-to-r from-purple-400 to-pink-400 hover:from-purple-500 hover:to-pink-500 text-white font-bold py-2 px-2 rounded-lg shadow-md active:shadow-inner transition-all duration-100 active:scale-95 text-xs"
              >
                {amount.label}
              </button>
            ))}
          </div>
        )}

        {/* Number Grid */}
        <div className="grid grid-cols-3 gap-3 mb-3">
          {['7', '8', '9', '4', '5', '6', '1', '2', '3'].map((num) => (
            <button
              key={num}
              onClick={() => handleNumberClick(num)}
              className={numberButtonClass}
            >
              {num}
            </button>
          ))}
        </div>

        {/* Bottom Row */}
        <div className="grid grid-cols-3 gap-3 mb-3">
          <button
            onClick={handleClear}
            className={dangerButtonClass}
          >
            C
          </button>
          <button
            onClick={() => handleNumberClick('0')}
            className={numberButtonClass}
          >
            0
          </button>
          {allowDecimal ? (
            <button
              onClick={() => handleNumberClick('.')}
              className={numberButtonClass}
            >
              .
            </button>
          ) : (
            <button
              onClick={handleBackspace}
              className={actionButtonClass}
            >
              ⌫
            </button>
          )}
        </div>

        {/* Action Buttons */}
        <div className="grid grid-cols-2 gap-3">
          {allowDecimal && (
            <button
              onClick={handleBackspace}
              className={actionButtonClass}
            >
              ⌫ ลบ
            </button>
          )}
          <button
            onClick={onClose}
            className={successButtonClass + (allowDecimal ? '' : ' col-span-2')}
          >
            ✓ ตกลง
          </button>
        </div>
      </div>
    </div>
  );
};

export default NumericKeyboard;
